var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendeeIocnTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#6226EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1847_7121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.25 12C12.1802 12 13.75 10.4302 13.75 8.5C13.75 6.56975 12.1802 5 10.25 5C8.31975 5 6.75 6.56975 6.75 8.5C6.75 10.4302 8.31975 12 10.25 12ZM10.25 6.16667C11.5368 6.16667 12.5833 7.21317 12.5833 8.5C12.5833 9.78683 11.5368 10.8333 10.25 10.8333C8.96317 10.8333 7.91667 9.78683 7.91667 8.5C7.91667 7.21317 8.96317 6.16667 10.25 6.16667ZM11.2714 14.4622C10.9389 14.3771 10.5947 14.3333 10.25 14.3333C7.99833 14.3333 6.16667 16.1656 6.16667 18.4167C6.16667 18.7392 5.90533 19 5.58333 19C5.26133 19 5 18.7392 5 18.4167C5 15.5216 7.3555 13.1667 10.25 13.1667C10.6933 13.1667 11.1343 13.2227 11.5619 13.3317C11.874 13.4122 12.0618 13.7302 11.9819 14.0422C11.902 14.3538 11.5847 14.5428 11.2714 14.4622ZM18.9837 12.6393C18.7562 13.5342 18.0451 15.234 16.5833 16.4147C15.9229 16.9478 15.2445 17.2722 14.625 17.4688C14.625 17.4688 15.2083 15.5 16.9968 13.4198C15.1867 14.422 13.897 16.2344 13.3352 17.7435C13.2302 18.0112 13.1445 18.2895 13.0693 18.5648C12.9981 18.8244 12.7572 19.0006 12.4877 19.0006C12.0887 19.0006 11.7923 18.6208 11.9014 18.237C11.9837 17.9477 12.0793 17.6537 12.1931 17.3649C12.2899 16.5716 12.7717 14.6378 14.3835 13.3364C15.8179 12.1779 17.5907 12.0006 18.4768 12.0012C18.8145 12.0012 19.0671 12.3127 18.9837 12.6399V12.6393Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1847_7121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendeeIocnTable);
export default __webpack_public_path__ + "static/media/AttendeeIocnTable.e7d8c043cca7162180ee7b30e8d0a08a.svg";
export { ForwardRef as ReactComponent };